import { render } from "./OtpPanel.vue?vue&type=template&id=22025917"
import script from "./OtpPanel.vue?vue&type=script&lang=ts"
export * from "./OtpPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script